// eslint-disable-next-line boundaries/no-unknown-files
import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { PAGE_ROUTE } from '@app/constants/page-route';
import { ErrorPageType } from '@app/enums/error-page-type';
import { MsalAuthService } from '@app/services/msal-auth/msal-auth.service';
import { AppStore } from '@app/stores/app/app.store';
@Injectable({
    providedIn: 'root',
})
export class AppClaimsGuard implements CanActivate {
    private msalAuthService = inject(MsalAuthService);
    private router = inject(Router);
    private appStore = inject(AppStore);

    async canActivate(): Promise<boolean | UrlTree> {
        const token = this.appStore.tkn();
        if (!token || this.msalAuthService.isTokenExpired(token)) {
            const token = await this.msalAuthService.getAccessToken();
            if (token) {
                return true;
            }
        }
        if (
            this.msalAuthService.hasAccessRoles() ||
            this.msalAuthService.hasSupplyChainAccessRoles()
        )
            return true;
        return this.router.navigate([
            `${PAGE_ROUTE.Main}/${PAGE_ROUTE.Error}/${ErrorPageType.Unauthorized}`,
        ]);
    }
}
